
import React from "react";
import { Theme } from "@radix-ui/themes";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ConvexReactClient } from "convex/react";
import { AuthenticatedApp } from "./components/AuthenticatedApp";
import { useAuth } from "@clerk/clerk-react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { getCurrentConvexUrl } from "@/config/deployments";
import { ThemeProvider } from "@/contexts/ThemeContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const convexClient = new ConvexReactClient(getCurrentConvexUrl());

const App = () => {
  return (
    <Theme appearance="inherit" accentColor="blue" radius="medium">
      <ThemeProvider>
        <ConvexProviderWithClerk client={convexClient} useAuth={useAuth}>
          <QueryClientProvider client={queryClient}>
            <TooltipProvider>
              <BrowserRouter>
                <AuthenticatedApp />
                <Toaster />
                <Sonner />
              </BrowserRouter>
            </TooltipProvider>
          </QueryClientProvider>
        </ConvexProviderWithClerk>
      </ThemeProvider>
    </Theme>
  );
};

export default App;
